import React from 'react';
import { connect } from 'react-redux';
import StatisticsByCreativeSegments from './StatisticsByCreativeSegments';

const StatisticsByCreativeSegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByCreativeSegments);

export default StatisticsByCreativeSegmentsComponent;
